const Login = async (username, password) => {
    try {
        const dataToSend = {
            username: username,
            password: password
        }

        const response = await fetch(process.env.REACT_APP_API_URL + `Authentication/login`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend)
            })

        if (!response.ok) {
            const error = await response.json()
            return { success: false, message: error.message || 'No ha sido posible iniciar sesión. Inténtalo nuevamente o inténtalo más tarde.' }
        }

        return { success: true, data: null }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar iniciar sesión. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

export { Login };